import { produce } from 'immer';
import { create } from 'zustand';

// internal
import * as state from '../types/store/permission-state';
import * as store from '../types/store/permission-handle';

const initState: state.PermissionState = {
  permissions: [],
  owner: false,
};

export const usePermissionStore = create<store.PermissionStore>((set, get) => ({
  ...initState,
  setPermission: (permissions, owner) => {
    set(
      produce<state.PermissionState>((state) => {
        (state.permissions = permissions), (state.owner = owner);
      }),
    );
  },
  checkPermission(modules: string) {
    const { permissions } = get();

    const modulePermission = modules.split(',');

    for (const module of modulePermission) {
      const [key, role] = module?.split('.');

      const dataCheck = role === 'viewer' ? key : module;

      for (const item of permissions) {
        if (item.includes(dataCheck)) {
          return true;
        }
      }
    }
    return false;
  },
  checkPermissionNew(modules: string[]) {
    // console.log('modules', modules);

    const { permissions } = get();
    // console.log('permissions', permissions);

    // for (const module of modules) {
    //     console.log(module);

    //     const hasPermit = permissions.some((perm) => module === perm)
    //     console.log('hasPermit', hasPermit);
    //     return hasPermit
    // }

    const hasPermission = modules.some((mod) => permissions.some((perm) => mod === perm));

    // console.log(hasPermission);

    return hasPermission;
  },
}));
